import { Button } from "../ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../ui/dialog";

export default function ADUsersDisableDialog({
  handleDisable,
  name,
  loading,
  onClose,
}: {
  handleDisable: () => void;
  name: string;
  loading: boolean;
  onClose: () => void;
}) {
  return (
    <Dialog
      onOpenChange={(value) => {
        if (!value) onClose();
      }}
      open={true}
    >
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>Desativar usuário</DialogTitle>
          <DialogDescription>
            Você tem certeza que deseja desativar <strong>{name}</strong>? Esta
            ação não pode ser desfeita.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button
            disabled={loading}
            onClick={handleDisable}
            variant={"destructive"}
          >
            {loading ? "Desabilitando..." : "Desativar"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
